const JobsQueryKeys = {
  all: ['JobList'],
  singleJob: ({ jobId }) => [...JobsQueryKeys.all, jobId],
  jobList: ({ page, limit }) => [...JobsQueryKeys.all, page, limit],
};

export default JobsQueryKeys;
